// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"84a51b34","650":"809ffe78","787":"a542a446","808":"b87c6360","983":"974296ae"}[chunkId] + ".chunk.js";
};